import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";
import Pagination from "../../shared/pagination";

const Product = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [subCategoryDrp, setSubCategoryDrp] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [productCount, setProductCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const debounceTimeout = useRef(null);
  const itemsPerPage = 30;

  const [formData, setFormData] = useState({
    category_id: null,
    size_id: null,
    sub_category_id: null,
  });

  const getProduct = (page = 1) => {
    setLoading(true);
    axios
      .post(API_URL.PRODUCT_LIST, {
        name: searchText,
        category_id: formData.category_id,
        sub_category_id: formData.sub_category_id,
        size_id: formData.size_id,
        page: page,
        limit: itemsPerPage,
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setProductData(res.data.data.data);
            const total = res.data.data.total || 0;
            setTotalPages(Math.ceil(total / itemsPerPage));
            setProductCount(total);
          }
          setIsLoaded(true);
          setLoading(false);
        },
        () => {
          setLoading(false);
          toast.error("Something went wrong..", { autoClose: 3000 });
        }
      );
  };

  const getSizeDrpData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      let cd = res.data.data.map((caw) => ({
        label: caw.name,
        value: caw.id,
      }));
      setSizeDrpData(cd);
    });
  };
  
  const getSubCategory = () => {
    axios.post(API_URL.SUB_CATEGORY_LIST, {active: 1}).then((res) => {
      let cd = res.data.data.map((caw) => ({
        label: caw.name,
        value: caw.id,
      }));
      setSubCategoryDrp(cd);
    });
  };

  const updateProductStatus = (id, status, name) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to " + (status == 1 ? "show" : "hide") + " this - " + name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, " + (status == 1 ? "show" : "hide") + " it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PRODUCT_UPDATE_STATUS, { id: id, active: status }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = productData.map((r) => r.id == id ? { ...r, active: status } : r);
              setProductData(newData);
              toast.success("Status Updated Successfully", { autoClose: 3000 });
            } else {
                toast.error(res.data.data, { autoClose: 3000 });
            }
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const deletProduct = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Product",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PRODUCT_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              toast.success(row.name + " deleted successfully", { autoClose: 3000 });
              getProduct(currentPage); // reload current page
            } else if (res.data.status === 0) {
              toast.error(res.data.data || "Product already used, you can not delete this product", { autoClose: 3000 });
            }
            setLoading(false);
          },
          () => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const styles = {
    menu: (baseStyles) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    getProduct(currentPage);
    getSizeDrpData();
    getSubCategory();
  }, []);

  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      if (isLoaded) {
        setCurrentPage(1); 
        getProduct(1);
      }
    }, 500);

    return () => clearTimeout(debounceTimeout.current);
  }, [searchText]);

  useEffect(() => {
    if (isLoaded) {
      setCurrentPage(1); 
      getProduct(1);
    }
  }, [formData.size_id, formData.sub_category_id]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getProduct(page);
  };

  return (
    <>
      <div className="row">
        <div className="col-2">
          <h1>
            Product <small className="me-2">({productCount})</small>
          </h1>
        </div>
        <div className="col-10">
          <div className="d-flex align-items-center justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <input type="text" className="form-control" placeholder="Search by name" value={searchText}  onChange={(e) => setSearchText(e.target.value)}/>
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <Select
                placeholder="Select Category"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={subCategoryDrp}
                isClearable
                value={subCategoryDrp.find((r) => r.value == formData.sub_category_id)}
                styles={styles}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    sub_category_id: (e) ? e.value : null,
                  });
                }}
              />
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <Select
                placeholder="Select Size"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={sizeDrp}
                isClearable
                value={sizeDrp.find((r) => r.value == formData.size_id)}
                styles={styles}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    size_id: (e) ? e.value : null,
                  });
                }}
              />
            </div>
            <Link to={"/product/add"} className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add Product
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader />}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Image</th>
                        <th>Name</th>
                        <th>In Stock</th>
                        <th>Category</th>
                        <th>Size</th>
                        <th style={{ width: "300px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productData.map((row, key) => (
                        <tr key={key}>
                          <td>{(currentPage - 1) * itemsPerPage + key + 1}</td>
                          <td className="table-avatar">
                            <div
                              style={{
                                backgroundImage: "url(" + row.image + ")",
                                height: 50,
                                width: 50,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                              }}
                            ></div>
                          </td>
                          <td>{row.name}</td>
                          <td>{row.in_stock}</td>
                          <td>{row.category_name}</td>
                          <td>{row.size_name}</td>
                          <td className="d-flex">
                            <Link to={`/product/edit/${row.id}`} className="btn btn-sm btn-secondary mr-2">
                              <i className="fa fa-edit me-1"></i> Edit
                            </Link>
                            { row.active == 1 && <button
                                onClick={() => updateProductStatus(row.id, 0, row.name)}
                                className="btn btn-sm btn-info mr-2"
                              >
                                <i className="fa fa-eye-slash me-1"></i> Hide
                              </button>
                              }
                              { row.active == 0 && <button
                                onClick={() => updateProductStatus(row.id, 1, row.name)}
                                className="btn btn-sm btn-success mr-2"
                              >
                                <i className="fa fa-eye me-1"></i> Show
                              </button>
                              }
                            <button onClick={() => deletProduct(row)} className="btn btn-sm btn-danger">
                              <i className="fa fa-trash me-1"></i> Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-center my-3">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Product;
